import type {Rooms} from 'src/types/scheduler/rooms';

import type {Dispatch, ThunkAction} from 'src/reducers';

import * as reduxApi from 'src/utils/redux-api-v2';

import {camel} from 'src/utils';


export const normalizeRoomsResponse = (response: unknown): Rooms => {
  if (!Array.isArray(response)) {
    return [];
  }
  return camel(response) as Rooms;
};

export const SET_ROOMS = 'scheduling/rooms/setRooms';

export type SchedulerRoomsActions = SetRooms;

export type SetRooms = {
  type: typeof SET_ROOMS;
  payload: Rooms;
};

export const setRooms = (payload: Rooms): SetRooms => ({
  type: SET_ROOMS,
  payload,
});

export type RoomsAccountsMe = {
  provider: string;
  syncState: 'valid' | 'invalid';
};

export const fetchRoomsAccountsMe =
  (): ThunkAction<RoomsAccountsMe> => async (dispatch: Dispatch) => {
    const response: RoomsAccountsMe = await dispatch(
      reduxApi.get('scheduler/rooms/accounts/me'),
    );
    return camel(response) as RoomsAccountsMe;
  };

export const getRoomsAuthUrl =
  (options?: {emailHint?: string; provider?: string}): ThunkAction<string> =>
  async (dispatch: Dispatch) => {
    const query: Record<string, string> = {};
    if (options?.emailHint) {
      query.email_hint = options.emailHint;
    }
    if (options?.provider) {
      query.provider = options.provider;
    }
    const response = await dispatch(
      reduxApi.get(
        'scheduler/rooms/accounts/auth/url',
        Object.keys(query).length ? query : undefined,
      ),
    );
    const {authUrl} = camel(response) as {authUrl: string};
    return authUrl;
  };

export type AuthenticateRoomsResponse = {syncState: string};

export const authenticateRooms =
  (code: string): ThunkAction<AuthenticateRoomsResponse> =>
  async (dispatch: Dispatch) => {
    const response = await dispatch(
      reduxApi.post('scheduler/rooms/accounts/auth', {code}),
    );
    return camel(response) as AuthenticateRoomsResponse;
  };

export const fetchRooms =
  (): ThunkAction<Rooms> => async (dispatch: Dispatch) => {
    const response = await dispatch(reduxApi.get('scheduler/rooms'));
    const rooms = normalizeRoomsResponse(response);
    dispatch(setRooms(rooms));
    return rooms;
  };

export const refreshRooms =
  (): ThunkAction<Rooms> => async (dispatch: Dispatch) => {
    const response = await dispatch(reduxApi.post('scheduler/rooms/refresh'));
    const rooms = normalizeRoomsResponse(response);
    dispatch(setRooms(rooms));
    return rooms;
  };
